import { render, staticRenderFns } from "./GoldStoneJpglistList.vue?vue&type=template&id=c50e7190&scoped=true&"
import script from "./GoldStoneJpglistList.vue?vue&type=script&lang=js&"
export * from "./GoldStoneJpglistList.vue?vue&type=script&lang=js&"
import style0 from "./GoldStoneJpglistList.vue?vue&type=style&index=0&id=c50e7190&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c50e7190",
  null
  
)

export default component.exports